import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';

import wrapIfString from '~/utils/react';
import Icon from './icon.component';

interface CardHeaderProps {
  title?: string | ReactElement;
  description?: string | ReactElement;
  showDivider?: boolean;
  open?: boolean;
  icon?: string;
  isDisclosure?: boolean;
  children?: ReactNode;
}

const CardHeader = ({
  title,
  description,
  children,
  showDivider,
  open,
  icon,
  isDisclosure,
}: CardHeaderProps) => {
  return (
    <>
      <div className="flex flex-row justify-between">
        <div
          className={classNames('bg-white flex justify-between items-center', {
            'w-full': !isDisclosure,
          })}
        >
          {icon && (
            <div className="pr-4">
              <Icon name={icon} />
            </div>
          )}
          <div className="flex-col text-left pb-2">
            {title && wrapIfString(title, 'h3')}
            {description}
          </div>
          {children}
        </div>
        <div className="h-full my-auto flex-col flex justify-center align-middle">
          {isDisclosure &&
            (open ? (
              <Icon name="ChevronUpIcon" />
            ) : (
              <Icon name="ChevronDownIcon" />
            ))}
        </div>
      </div>
      {showDivider && (
        <div className="w-full border-solid border-b border-gray-200 mb-4" />
      )}
    </>
  );
};

export default CardHeader;
